// extracted by mini-css-extract-plugin
export default {"root":"VoteForm_root__1rcXD","title":"VoteForm_title__gIgyH"};